// src/layouts/customer/CustomerMasterLayout.jsx

import React, { useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import CustomerSidebar, { HamburgerBtn, usePageLabel } from "../../components/customer/customerPannel/CustomerSidebar";
import "../../assets/css/customer/customermasterlayout/CustomerMasterLayout.css";

const CustomerMasterLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const pageLabel = usePageLabel(location.pathname);

  const handleClose  = useCallback(() => setSidebarOpen(false), []);
  const handleToggle = useCallback(() => setSidebarOpen(p => !p), []);

  return (
    <div className="cml-layout-wrapper">

      <CustomerSidebar
        open={sidebarOpen}
        onClose={handleClose}
        onToggle={handleToggle}
      />

      <main className="cml-main-content" id="main-content">

        {/* Mobile-only sticky top header */}
        <header className="cml-mobile-header">
          <HamburgerBtn open={sidebarOpen} onToggle={handleToggle} />
          <span className="cml-mobile-page-title">{pageLabel}</span>
        </header>

        <div className="cml-content-wrapper">
          {children}
        </div>

      </main>
    </div>
  );
};

export default CustomerMasterLayout;